// src/hooks/useActivaClass.ts
import type { ActivaState } from "@/engines/activaRuntime";

const ACTIVA_CLASS_MAP: Record<ActivaState, string> = {
  FlowAligned: "activa-flow",
  ThresholdState: "activa-threshold",
  EmotionalShift: "activa-shift",
  BlockedResistance: "activa-blocked",
  BreakthroughEmerging: "activa-breakthrough",
};

export const useActivaClass = (activa: ActivaState) => ACTIVA_CLASS_MAP[activa];
